import React, {useState} from 'react';
import {useLazyQuery} from '@apollo/client';
import {Button, Checkbox, DatePicker, Form, Input} from 'antd'
import {MaskedInput} from 'antd-mask-input';
import dayjs from 'dayjs';

import {ENUM_REFUNDREQUEST_TEMPLATE} from '../../../__generated__/global-types';
import {DOC_ADVERTISEMENT, DOC_PERSONAL_DATA, DOC_SIGNATURE} from '../../../config/routes';
import {IFormRefundFree} from '../../../shared/forms/forms';
import {checkCertNumber, checkCertNumberVariables} from '../../../shared/graphql/__generated__/checkCertNumber';
import {QUERY_CHECK_CERT_NUMBER} from '../../../shared/graphql/refund';
import {
    accountRegex,
    bankRegex,
    certRegex,
    passportCodeRegex,
    passportRegex,
    phoneRegex
} from '../../../shared/helpers/regex';
import {validateRs} from '../../../shared/helpers/validate';

import cls from './RefundFreeForm.module.scss'

interface RefundFreeFormProps {
    onComplete: (values: IFormRefundFree) => void
    loading: boolean
    disabled: boolean
}

const RefundFreeForm = ({onComplete, loading, disabled}: RefundFreeFormProps) => {

    const [form] = Form.useForm()
    const [termsAccepted, setTermsAccepter] = useState<boolean>(true)
    const [adAccepted, setadAccepter] = useState<boolean>(true)
    const [sbp, setSbp] = useState<boolean>(true)

    const [bank, setBank] = useState<boolean>(false)
    const [checkCertNumber] = useLazyQuery<checkCertNumber, checkCertNumberVariables>(QUERY_CHECK_CERT_NUMBER)

    const onFinish = (values: IFormRefundFree) => {
        onComplete({
            ...values,
            Bank_Name: bank ? values.Bank_Name : '',
            Bank_Number: bank ? values.Bank_Number : '',
            Bank_Account: bank ? values.Bank_Account : '',
            Bank_Correspondent: bank ? values.Bank_Correspondent : '',
            Bank_FIO: bank ? values.Bank_FIO : '',
            termsAccepted,
            adAccepted,
        })
    }

    const beforeFinish = (values: IFormRefundFree) => {
        // trim values
        form.setFieldValue('First_Name', values.First_Name.trim())
        form.setFieldValue('Last_Name', values.Last_Name.trim())
        form.setFieldValue('Middle_Name', values.Middle_Name.trim())
        if (bank) {
            form.setFieldValue('Bank_FIO', values.Bank_FIO.trim())
        }
        form.validateFields()
            .then(() => onFinish(form.getFieldsValue()))
            .catch(error => console.log(error))
    }

    const certNumberValidate = async (rule: any, value: any) => {
        let error = false
        const queryResult = await checkCertNumber({
            variables: {Certificate_Number: value},
            onError: () => error = true
        });
        if (!error) {
            const valid = queryResult.data?.checkCertNumber.template !== ENUM_REFUNDREQUEST_TEMPLATE.CERT_NUMBER_ERROR
            setBank(queryResult.data?.checkCertNumber.details!)
            if (valid) {
                return Promise.resolve();
            } else {
                return Promise.reject('Ошибка в номере сертификата');
            }
        } else {
            return Promise.reject('Ошибка, попробуйте еще раз');
        }
    };

    const rsValidate = async (rule: any, value: any) => {
        // validateRs(value, form.getFieldValue('Bank_Number'))
        if (form.getFieldError('Bank_Number').length) {
            return Promise.reject('Заполните поле БИК');
        }
        const bik = form.getFieldValue('Bank_Number')
        if (bik && bankRegex.test(bik)) {
            console.log('bik', bik)
            console.log('value', value)
            return await validateRs(value, bik)
        } else {
            await Promise.reject('Заполните корректно БИК')
        }
        // if (!error) {
        //     const valid = queryResult.data?.checkCertNumber.template !== ENUM_REFUNDREQUEST_TEMPLATE.CERT_NUMBER_ERROR
        //     setBank(queryResult.data?.checkCertNumber.details!)
        //     if (valid) {
        //         return Promise.resolve();
        //     } else {
        //         return Promise.reject('Ошибка в номере сертификата');
        //     }
        // } else {
        //     return Promise.reject('Ошибка, попробуйте еще раз');
        // }
    }

    const disabledDate = (current: any) =>
        // Can not select days before today and today
        current && current > dayjs()
    ;

    return (
        <Form form={form} layout={'vertical'} size={'large'}
              validateTrigger={'onChange'}
              scrollToFirstError={true}
              onFinish={beforeFinish}
              disabled={loading || disabled}
        >

            <h3>Сертификат</h3>
            <Form.Item name={'Certificate_Number'} label={'Номер сертификата'}
                       hasFeedback
                       validateFirst={true}
                       validateDebounce={1000}
                       rules={[
                           {required: true, message: 'Заполните, пожалуйста'},
                           // {pattern: latinRegex, message: 'Только латинские буквы и цифры'},
                           {pattern: certRegex, message: 'Не соответствует формату номера сертификата'},
                           {validator: certNumberValidate}
                       ]}>
                <Input placeholder={'23000NSB176000000'}/>
            </Form.Item>
            <Form.Item name={'Certificate_Date'} label={'Дата выдачи сертификата'}
                       rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <DatePicker format={'DD.MM.YYYY'} placeholder={'01.01.2000'} disabledDate={disabledDate}/>
            </Form.Item>

            <h3>Данные заявителя</h3>
            <Form.Item name={'Last_Name'} label={'Фамилия'} rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <Input placeholder={'Иванов'}/>
            </Form.Item>
            <Form.Item name={'First_Name'} label={'Имя'} rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <Input placeholder={'Иван'}/>
            </Form.Item>
            <Form.Item name={'Middle_Name'} label={'Отчество'}>
                <Input placeholder={'Иванович'}/>
            </Form.Item>
            <Form.Item name={'Birthday'} label={'Дата рождения'}
                       rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <DatePicker format={'DD.MM.YYYY'} placeholder={'01.01.2000'} disabledDate={disabledDate}/>
            </Form.Item>

            <Form.Item name={'Phone'} label={'Номер телефона'} rules={[
                {required: true, message: 'Заполните, пожалуйста'},
                {pattern: phoneRegex, message: 'Не соответствует формату номера телефона'}
            ]}>
                <MaskedInput disabled={loading || disabled} mask={'+7 (000) 000-00-00'}
                             placeholder={'+7 (999) 888-77-66'} size={'large'}/>
            </Form.Item>
            {bank &&
                <Form.Item>
                    <div className={cls.checkbox}>
                        <Checkbox checked={sbp} onChange={() => setSbp(!sbp)}/>
                        <div>
                            Проинформирован о&nbsp;том, что денежные средства могут быть возвращены мне посредством
                            перевода
                            через систему СБП на&nbsp;номер расчетного счета, привязанный к&nbsp;указанному мной номеру
                            телефона.
                            Уведомлен и&nbsp;согласен с&nbsp;тем, что ответственность за&nbsp;достоверность
                            и&nbsp;корректность указанный мной данных лежит полностью на&nbsp;мне. Согласен с&nbsp;тем,
                            что
                            Компания не&nbsp;несет ответственности в&nbsp;случае, если указанный телефон
                            не&nbsp;принадлежит
                            мне и&nbsp;денежные средства были переведены Компанией через систему СБП тому, кому
                            принадлежит
                            указанный мной номер мобильного телефона.
                        </div>
                    </div>
                </Form.Item>
            }
            <Form.Item name={'Email'} label={'Email'} rules={[{required: true, message: 'Заполните, пожалуйста'}, {
                type: 'email',
                message: 'Не соответствует формату email'
            }]}>
                <Input onChange={(e) => form.setFieldValue('Email', e.target.value.trim())}
                       placeholder={'name@example.com'}/>
            </Form.Item>

            <h3>Паспортные данные</h3>
            <Form.Item name={'Passport'} label={'Серия и номер паспорта'} rules={[
                {required: true, message: 'Заполните, пожалуйста'},
                {pattern: passportRegex, message: 'Не соответствует формату серии и номера паспорта'}
            ]}>
                <MaskedInput disabled={loading || disabled} mask={'0000 000000'} placeholder={'0000 000000'}
                             size={'large'}/>
            </Form.Item>
            <Form.Item name={'Passport_Code'} label={'Код подразделения'} rules={[
                {required: true, message: 'Заполните, пожалуйста'},
                {pattern: passportCodeRegex, message: 'Не соответствует формату кода подразделения'}
            ]}>
                <MaskedInput disabled={loading || disabled} mask={'000-000'} placeholder={'000-000'}
                             size={'large'}/>
            </Form.Item>
            <Form.Item name={'Passport_Issuer'} label={'Кем выдан'} rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <Input placeholder={'Отдел УФМС Росиии по городу Москва'}/>
            </Form.Item>
            <Form.Item name={'Passport_Date'} label={'Дата выдачи паспорта'}
                       rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <DatePicker format={'DD.MM.YYYY'} placeholder={'01.01.2000'} disabledDate={disabledDate}/>
            </Form.Item>

            {bank &&
                <>
                    <h3>Банковские реквизиты</h3>
                    <Form.Item name={'Bank_Name'} label={'Наименование банка'}
                               rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                        <Input placeholder={'Банк России'}/>
                    </Form.Item>
                    <Form.Item name={'Bank_Correspondent'} label={'Корр. счет'} rules={[
                        {required: true, message: 'Заполните, пожалуйста'},
                        {pattern: accountRegex, message: 'Не соответствует формату номера счета'}
                    ]}>
                        <Input onChange={(e) => form.setFieldValue('Bank_Correspondent', e.target.value.trim())}
                               placeholder={'30101810900000000746'}/>
                    </Form.Item>
                    <Form.Item name={'Bank_Number'} label={'БИК'} rules={[
                        {required: true, message: 'Заполните, пожалуйста'},
                        {pattern: bankRegex, message: 'Только 9 цифр'}
                    ]}>
                        <Input onChange={(e) => form.setFieldValue('Bank_Number', e.target.value.trim())}
                               placeholder={'044525600'}/>
                    </Form.Item>
                    <Form.Item name={'Bank_Account'} label={'Номер счета получателя'}
                               validateFirst={true}
                               rules={[
                                   {required: true, message: 'Заполните, пожалуйста'},
                                   {pattern: accountRegex, message: 'Только 20 цифр'},
                                   {validator: rsValidate}
                               ]}
                               dependencies={['Bank_Number']}
                    >
                        <Input onChange={(e) => form.setFieldValue('Bank_Account', e.target.value.trim())}
                               placeholder={'40817810712532748696'}/>
                    </Form.Item>
                    <Form.Item
                        name={'Bank_FIO'}
                        label={'ФИО владельца счета'}
                        help={'ФИО владельца счета должно совпадать с ФИО владельца Сертификата. Вернуть денежные средства на расчетный счет иного лица не получится.'}
                        rules={[{required: true, message: 'Заполните, пожалуйста'}]}
                    >
                        <Input placeholder={'Иванов Иван Иванович'}/>
                    </Form.Item>
                    <div style={{marginTop: 40}}/>
                </>
            }
            <Form.Item>
            <Checkbox checked={termsAccepted} onChange={() => setTermsAccepter(!termsAccepted)}>Я ознакомился и соглашаюсь с <a href={DOC_PERSONAL_DATA} rel={'noreferrer'} target={'_blank'}>правилами обработки персональных данных</a> и <a href={DOC_SIGNATURE} rel={'noreferrer'} target={'_blank'}>правилами использования простой электронной подписи</a></Checkbox>
            </Form.Item>
            <Form.Item>
                <Checkbox checked={adAccepted} onChange={() => setadAccepter(!adAccepted)}>Я соглашаюсь на получение <a href={DOC_ADVERTISEMENT} target={'_blank'} rel={'noreferrer'}>информационных и рекламных материалов</a></Checkbox>
            </Form.Item>
            {bank &&
                <Form.Item>
                    <p className={'caption'}>
                        Подписывая настоящее Заявление посредством внесения уникального кода из&nbsp;письма,
                        направленного на&nbsp;электронный адрес Клиента, указанный при заполнении формы на&nbsp;сайте
                        Компании, Клиент подтверждает, что ознакомлен и&nbsp;согласен с&nbsp;тем, что самостоятельно
                        несет ответственность за&nbsp;корректность предоставленных банковских реквизитов и&nbsp;данных
                        в&nbsp;заявление на&nbsp;возврат стоимости присоединения к&nbsp;Оферте &laquo;Финансовая
                        защита&raquo; и/или &laquo;Иммунитет+&raquo;. Данной подписью Клиент подтверждает, что
                        ознакомлен и&nbsp;согласен с&nbsp;тем, что в&nbsp;случае указания им&nbsp;в&nbsp;заявление
                        на&nbsp;возврат стоимости присоединения к&nbsp;Оферте некорректных и/или не&nbsp;действительных
                        банковских реквизитов, повлекших за&nbsp;собой возврат на&nbsp;расчетный счет Компании ранее
                        направленной Клиенту суммы денежных средств, Компания вправе при повторной операции возврата
                        стоимости присоединения к&nbsp;Оферте, в&nbsp;рамках исполнения одного и&nbsp;того&nbsp;же
                        заявления Клиента, удержать из&nbsp;суммы возврата штраф в&nbsp;размере 3,2% от&nbsp;стоимости
                        присоединения к&nbsp;Оферте, указанной в&nbsp;Сертификате. Компания вправе налагать данный
                        штраф, в&nbsp;рамках исполнения одного и&nbsp;того&nbsp;же заявления Клиента, эквивалентное
                        количество раз предоставление Клиентом некорректных банковских реквизитов.
                    </p>
                </Form.Item>
            }
            <Form.Item>
                <Button type={'primary'} htmlType={'submit'} disabled={!termsAccepted || !sbp || loading || disabled}
                        loading={loading}>Отправить
                    запрос</Button>
            </Form.Item>
        </Form>
    )
}

export default RefundFreeForm